(function() {
    'use strict';

    angular
        .module('masterApp')
        .controller('InputPrController', InputPrController);

    InputPrController.$inject = ['$scope', '$state', 'DataUtils', 'InputPr','$uibModal'];

    function InputPrController ($scope, $state, DataUtils, InputPr, $uibModal) {
    	var vm = this;
    	vm.toggleValue = false;
    	vm.flgValue = false;
    	loadAll();
    	function loadAll() {
    		InputPr.get({urlItem:'input-pr'},function(result) {
    			if(result != null && result.value =='1'){
    				vm.toggleValue = true;
    				vm.flgValue = true
    			}else{
    				vm.toggleValue = false;
    				vm.flgValue = false;
    			}
            },function(error){
            	vm.toggleValue = false;
            }
            );
        }
    	vm.savePr = function (toggleValue){
    	 var modalInstance = $uibModal
			.open({
				animation : true,
				templateUrl : GLOBAL_URL
				+ 'partial?uri=master/input-pr/input-pr-confirm-dialog',
				controller : 'InputPrConfirmController',
				controllerAs : 'vm',
				resolve : {
					toggleValue : function() {
						return toggleValue;
					}
				}
			});
			modalInstance.result.then(function(result) {
				modalInstance = null;
				if (result == '1') {
					InputPr.save({urlItem:'save-input-pr'},function(result) {
		    			if(result != null && result.value =='1'){
		    				vm.toggleValue = true;
		    				vm.flgValue = true;
		    			}else{
		    				vm.toggleValue = false;
		    				vm.flgValue = false;
		    			}
		            },function(error){
		            	vm.toggleValue = false;
		            	vm.flgValue = false;
		            });
				} else if (result == '0') {
					vm.toggleValue = vm.flgValue;
				}
				modalInstance = null;
			}, function(error) {
				vm.toggleValue = vm.flgValue;
		});
    	}
    }
})();
